export const SPACING = {
    XXS: '0.25rem',
    XS: '0.5rem',
    S: '0.75rem',
    M: '1rem',
    L: '1.25rem',
    XL: '1.5rem',
    XXL: '1.75rem',
};
